export const RequiredDocuments = [
  'ADDRESS_DOCUMENT',
  'SSN_DOCUMENT',
  'DOB_DOCUMENT',
  'NAME_DOCUMENT',
  'RESIDENT_ALIEN_DOCUMENT'
];
